// 文字列が実際に描画される幅をcanvasで測る。文字幅を定数で近似すると、フォントの指定が
// 変わったときに測定側だけ追随できなくなるため、描画に使う font 指定をそのまま渡して測る。
// 計測用のコンテキストはfontごとに使い回す。
const measureContexts = new Map<string, CanvasRenderingContext2D | null>()

export const measureTextWidthPx = (text: string, font: string): number => {
  if (!measureContexts.has(font)) {
    const context = document.createElement('canvas').getContext('2d')
    if (context) {
      context.font = font
    }
    measureContexts.set(font, context)
  }
  return measureContexts.get(font)?.measureText(text).width ?? 0
}
